/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionalComplianceInfoRequest = {
  properties: {
    professionalId: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
